"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var NumberOfBirths_1 = __importDefault(require("../component/NumberOfBirths"));
var DeliveryDate_1 = __importDefault(require("../component/DeliveryDate"));
var DeliveryStyle_1 = __importDefault(require("../component/DeliveryStyle"));
var IsComplicationsBefore_1 = __importDefault(require("../component/IsComplicationsBefore"));
var HospitalName_1 = __importDefault(require("../component/HospitalName"));
var ReportOfChildbirth = /** @class */ (function (_super) {
    __extends(ReportOfChildbirth, _super);
    function ReportOfChildbirth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportOfChildbirth.prototype.render = function () {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("h2", { className: "heading02" }, "\u51FA\u7523\u306E\u5831\u544A"),
            react_1.default.createElement("div", { className: "form__container" },
                react_1.default.createElement("p", { className: "form__heading" }, "\u5206\u5A29\u60C5\u5831"),
                react_1.default.createElement("div", { className: "form__block" },
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("div", { className: "form__title" },
                            react_1.default.createElement("label", { htmlFor: "baby-count", className: "form__label" }, "\u51FA\u7523\u5150\u6570"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(NumberOfBirths_1.default, null))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("fieldset", { className: "form__field" },
                            react_1.default.createElement("legend", { className: "form__title" },
                                react_1.default.createElement("span", { className: "form__label" }, "\u5206\u5A29\u65E5"),
                                react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                            react_1.default.createElement("div", { className: "form__input" },
                                react_1.default.createElement(DeliveryDate_1.default, null)))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("fieldset", { className: "form__field" },
                            react_1.default.createElement("legend", { className: "form__title" },
                                react_1.default.createElement("span", { className: "form__label" }, "\u5206\u5A29\u69D8\u5F0F"),
                                react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                            react_1.default.createElement("div", { className: "form__input" },
                                react_1.default.createElement(DeliveryStyle_1.default, null)))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("fieldset", { className: "form__field" },
                            react_1.default.createElement("legend", { className: "form__title" },
                                react_1.default.createElement("span", { className: "form__label" }, "\u598A\u5A20\u6642\u306E\u5408\u4F75\u75C7\u306E\u6709\u7121"),
                                react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                            react_1.default.createElement("div", { className: "form__input" },
                                react_1.default.createElement(IsComplicationsBefore_1.default, null)))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("div", { className: "form__title" },
                            react_1.default.createElement("label", { htmlFor: "clinic-name", className: "form__label" }, "\u51FA\u7523\u75C5\u9662\u540D"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(HospitalName_1.default, null)))))));
    };
    return ReportOfChildbirth;
}(react_1.Component));
exports.default = ReportOfChildbirth;
